import { useTranslation } from 'react-i18next';
import Administration from "../components/Administration";
import "./userSettings.css";

// /my-account — personal account settings only. Workspaces and Team
// members are account-level concerns and now live on their own pages
// (/workspaces, /team-members), reachable from the sidebar next to Agents.
const UserSettings = ({ logoutUser, onSave }) => {
  const { t } = useTranslation();
  return (
    <div className="account-settings">
      <header className="section-head">
        <h1 className="section-head-title">{t('account_settings_title')}</h1>
        <p className="section-head-sub">
          {t('account_settings_subtitle')}
        </p>
      </header>

      <Administration logoutUser={logoutUser} onSave={onSave} />
    </div>
  );
};

export default UserSettings;
